import React from "react";

interface ModalStatsProps {
  totalItems: number;
  totalOccurrences: number;
  totalCalories: number;
}

export default function ModalStats({
  totalItems,
  totalOccurrences,
  totalCalories,
}: ModalStatsProps) {
  return (
    <div className="mb-4 sm:mb-6 grid grid-cols-2 gap-3 sm:gap-4 sm:grid-cols-4">
      <div className="rounded-lg sm:rounded-xl border border-stroke bg-white p-3 sm:p-4 shadow-sm dark:border-strokedark dark:bg-boxdark">
        <p className="text-xs font-medium text-gray-600 dark:text-gray-400">
          Itens
        </p>
        <p className="mt-1 text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
          {totalItems}
        </p>
      </div>
      <div className="rounded-lg sm:rounded-xl border border-stroke bg-white p-3 sm:p-4 shadow-sm dark:border-strokedark dark:bg-boxdark">
        <p className="text-xs font-medium text-gray-600 dark:text-gray-400">
          Ocorrências
        </p>
        <p className="mt-1 text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
          {totalOccurrences}
        </p>
      </div>
      <div className="col-span-2 rounded-lg sm:rounded-xl border border-stroke bg-white p-3 sm:p-4 shadow-sm dark:border-strokedark dark:bg-boxdark">
        <p className="text-xs font-medium text-gray-600 dark:text-gray-400">
          Total de Calorias
        </p>
        <p className="mt-1 text-lg sm:text-xl font-bold text-purple-600 dark:text-purple-400">
          {totalCalories.toLocaleString("pt-BR")} kcal
        </p>
      </div>
    </div>
  );
}
